import gql from 'graphql-tag';
import React from 'react';
import {
  CheckoutDisplayFields,
} from '../schemas/rql';
import { CheckoutStep, PAYMENT_STEP, SHIPPING_STEP } from '../lib/checkout_step';

type Checkout = CheckoutDisplayFields.Fragment;

export interface CheckoutDisplay {
  step: CheckoutStep;
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
  layoutQueryName: string;
}

export const CheckoutDisplayContext = React.createContext<CheckoutDisplay>({
  step: SHIPPING_STEP,
  isLoading: false,
  setLoading: (_) => { },
  layoutQueryName: null,
});

/**
 * Use to access the checkout layout's state
 */
export function useCheckoutDisplay() {
  return React.useContext(CheckoutDisplayContext);
}

/**
 * Use to hydrate a layout with a loading state.
 *
  * Only necessary once per top-level checkout layout
 */
export function useCheckoutDisplayState(checkout: Checkout, layoutQueryName: string): CheckoutDisplay {
  const [isLoading, setLoading] = React.useState(false);
  const step = findCheckoutStep(checkout);

  return {
    step,
    isLoading,
    setLoading,
    layoutQueryName,
  };
}

export function findCheckoutStep(checkout: Checkout): CheckoutStep {
  if (!checkout?.shippingAddress?.isComplete) {
    return SHIPPING_STEP;
  }

  return PAYMENT_STEP;
}

export const CheckoutDisplayFragment = gql`
  fragment CheckoutDisplayFields on Checkout {
    _id
    shippingAddress {
      isComplete
    }
    paymentMethod {
      isComplete
    }
  }
`;
